export const BULLET_ACTIVATION_PERIOD_IN_MS = 500;
